import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { store } from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "home" */ "@/views/HomeView.vue"
      ),
  },
  {
    path: "/info",
    name: "info",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "info" */ "@/views/InfoView.vue"
      ),
  },
  {
    path: "/bujin",
    name: "bujin",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "bujin" */ "@/views/BujinkanView.vue"
      ),
  },
  {
    path: "/seminar",
    name: "seminar",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "bujin" */ "@/views/SeminarView.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from) => {
  if (
    !store.getters.getAuthState &&
    to.name !== "home" &&
    to.name !== "info" &&
    to.name !== "bujin" &&
    to.name !== "seminar"
  ) {
    return { name: "home" };
  }
});

export default router;
